import { CoreIcon } from '../core-icon';
import mochiCoinCircleFillSVG from '../../assets/icons/mochi-coin-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const MochiCoinCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mochiCoinCircleFillSVG} {...props} />;
};
